import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatListModule } from "@angular/material/list";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";
import { MaterialModule } from "src/app/material.module";
import { ConnectorZBEQuickActionsBottomSheetService } from "./connector-zbe-quickactions-bottom-sheet.service";
import { CluBeSnackbarService } from "../../apps/@services/clube-snackbar.service";
import { CommonModule } from "@angular/common";
import { NotificationService, NotificationRef, NotificationSettings, } from "@progress/kendo-angular-notification";
import { ZBEQuickActionsSyncSageComponent } from "./quickactions-components/zbe-quickactions-sync-sage/zbe-quickactions-sync-sage.component";
import { KendoModule } from "src/app/kendo.module";
import { MdRunnerTaskSyncDialogComponent } from "../md-runner-task-sync-dialog/md-runner-task-sync-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { BreakpointObserver } from "@angular/cdk/layout";
import { Subscription } from "rxjs";
import { CluPMediaOptions } from "../../apps/@models/clupmediaoptions.model";
import { MOBILE_VIEW, MOBILE_VIEW_L, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR, BELOWMONITOR_L, BELOWMONITOR_M, BELOWMONITOR_L1100, Model_RunnerTask } from "src/app/app.models";

@Component({
    selector: 'zbe-quickactions-bottom-sheet',
    templateUrl: 'zbe-quickactions-bottom-sheet.component.html',
    styleUrls: ['./zbe-quickactions-bottom-sheet.component.scss'],
    standalone: true,
    imports: [CommonModule, KendoModule, MaterialModule, TranslateModule, TablerIconsModule, FormsModule, MdRunnerTaskSyncDialogComponent],
    providers: [ConnectorZBEQuickActionsBottomSheetService, CluBeSnackbarService]
  })
  export class ZBEQuickActionsBottomSheetComponent {
    
    private layoutChangesSubscription = Subscription.EMPTY;
    mediaOptions : CluPMediaOptions = new CluPMediaOptions();

    constructor(
      private _bottomSheetRef: MatBottomSheetRef<ZBEQuickActionsBottomSheetComponent>, 
      private connector : ConnectorZBEQuickActionsBottomSheetService, 
      private _snackbarService : CluBeSnackbarService, 
      private notificationService: NotificationService,
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    ) {
      // BREAKPOINTS
      this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, MOBILE_VIEW_L, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR, BELOWMONITOR_L, BELOWMONITOR_M, BELOWMONITOR_L1100])
      .subscribe((state) => {
        this.mediaOptions.LAYOUT_MOBILE_VIEW_L = state.breakpoints[MOBILE_VIEW_L];
        this.mediaOptions.LAYOUT_MOBILE_VIEW = state.breakpoints[MOBILE_VIEW];
        this.mediaOptions.LAYOUT_BELOWMONITOR = state.breakpoints[BELOWMONITOR];
        this.mediaOptions.LAYOUT_BELOWMONITOR_L = state.breakpoints[BELOWMONITOR_L];
        this.mediaOptions.LAYOUT_BELOWMONITOR_L1100 = state.breakpoints[BELOWMONITOR_L1100];
        this.mediaOptions.LAYOUT_BELOWMONITOR_M = state.breakpoints[BELOWMONITOR_M];
      });
    }
  
    openLink(event: MouseEvent): void {
      this._bottomSheetRef.dismiss();
      event.preventDefault();
    }
    
    showLoader : Map<'SAGE_100_C_SYNCHRONISATION_STRUCTURES' | 'SAGE_100_C_SYNCHRONISATION_STOCK', boolean> = new Map<'SAGE_100_C_SYNCHRONISATION_STRUCTURES' | 'SAGE_100_C_SYNCHRONISATION_STOCK', boolean>([
      ['SAGE_100_C_SYNCHRONISATION_STRUCTURES', false],
      ['SAGE_100_C_SYNCHRONISATION_STOCK', false]
    ]);

    async doSaveRunnerTasksAction_BOAdmSageLink(_typeTask : 'SAGE_100_C_SYNCHRONISATION_STRUCTURES' | 'SAGE_100_C_SYNCHRONISATION_STOCK', event: MouseEvent){
      if(this.showLoader.get(_typeTask) == true) return;
      switch(_typeTask){
        case 'SAGE_100_C_SYNCHRONISATION_STRUCTURES': 
          try {
            this.showLoader.set(_typeTask, true);
            const res = await this.openRunnerTaskSyncDialog('SAGE_100_C_SYNCHRONISATION_STRUCTURES');
            this.showLoader.set(_typeTask, false);
            if (!!res) {
              this._snackbarService.displayMessage("SUCCESS", "Une synchronisation a été lancée..");
              switch(_typeTask){
                case 'SAGE_100_C_SYNCHRONISATION_STRUCTURES' : this.showProgressNotificationAction_SYNCSAGE(res); break;
              }
            }
            this._bottomSheetRef.dismiss();
            event.preventDefault();
          } catch(err: any) {
            console.error(err);
            if(err.error != undefined && err.error.Message != undefined){ this._snackbarService.displayMessage("ERROR", err.error.Message); }
            else { this._snackbarService.displayMessage("ERROR", "Une erreur est survenue lors de l'enregistrement.."); }
            this.showLoader.set(_typeTask, false);
          }
          break;
        case 'SAGE_100_C_SYNCHRONISATION_STOCK': 
          try {
            this.showLoader.set(_typeTask, true);
            const res = await this.openRunnerTaskSyncDialog('SAGE_100_C_SYNCHRONISATION_STOCK');
            this.showLoader.set(_typeTask, false);
            if (!!res) {
              this._snackbarService.displayMessage("SUCCESS", "Une synchronisation a été lancée..");
              switch(_typeTask){
                case 'SAGE_100_C_SYNCHRONISATION_STOCK' : this.showProgressNotificationAction_SYNCSAGE(res); break;
              }
            }
            this._bottomSheetRef.dismiss();
            event.preventDefault();
          } catch(err: any) {
            console.error(err);
            if(err.error != undefined && err.error.Message != undefined){ this._snackbarService.displayMessage("ERROR", err.error.Message); }
            else { this._snackbarService.displayMessage("ERROR", "Une erreur est survenue lors de l'enregistrement.."); }
            this.showLoader.set(_typeTask, false);
          }
          break;
        default : return;
      }
    }

    private openRunnerTaskSyncDialog(_typeTask : 'SAGE_100_C_SYNCHRONISATION_STRUCTURES' | 'SAGE_100_C_SYNCHRONISATION_STOCK') {
      return new Promise<Model_RunnerTask[]>((resolve, reject) => {
        let CC_WIDTH = this.mediaOptions.LAYOUT_BELOWMONITOR ? '100%' : '600px';
        const dialogRef = this.dialog.open(MdRunnerTaskSyncDialogComponent, { 
          width: '100%', maxWidth: CC_WIDTH, data: { TYPE_RUNNER_JOB_ID: _typeTask },
        });
        dialogRef.afterClosed().subscribe((result: any) => resolve(result));
      });
    }

    private showProgressNotificationAction_SYNCSAGE(_tasks : Model_RunnerTask[]) : void {
      _tasks.forEach(task => {
        const notificationRef: NotificationRef = this.notificationService.show({
          content: ZBEQuickActionsSyncSageComponent,
          animation: { type: "slide", duration: 200  },
          position: { horizontal: "right", vertical: "bottom" },
          type: { style: "none", icon: false },
          closable: true,
        });
        if (notificationRef) { 
          const notificationInstance = notificationRef.content!.instance;
          notificationInstance.inputRes = task;
          notificationRef.content!.instance.ignore.subscribe(() => notificationRef.hide() ); 
        }
      });
    }

  }